import { render } from "./DashboardView.vue?vue&type=template&id=10dc39f6"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/DashboardView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10dc39f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10dc39f6', __exports__)) {
    api.reload('10dc39f6', __exports__)
  }
  
  module.hot.accept("./DashboardView.vue?vue&type=template&id=10dc39f6", () => {
    api.rerender('10dc39f6', render)
  })

}


export default __exports__